import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import { Spinner } from '@vwfs-bronson/bronson-react';
// import { FSOVManagementLayout } from "../hoc/FSOVManagementLayout";
import Initializer from '../hoc/Initializer';
import AuthPage from '../pages/AuthPage';
import { CheckoutPage } from '../pages/CheckoutPage';
import { ErrorPage } from '../pages/ErrorPage';
import { SearchPage } from '../pages/SearchPage';
// import { ImanPage } from "../pages/ImanPage";
import { lazy, Suspense } from 'react';
import { WizardPage } from '../pages/WizardPage';
import { useModuleLoad } from '../hooks/useModuleLoad';
import { ConfigurationCreatorPage } from '../pages/ConfigurationCreatorPage';

const FSOVManagementLayoutLazy = lazy(
  () => import('../hoc/FSOVManagementLayout'),
);

const SimulatorLayoutLazy = lazy(() => import('../hoc/SimulatorLayout'));

const RemoteCalculatorApp = lazy(() =>
  import('remoteCalculatorApp/CalculatorApp').catch(
    () => import('../pages/NotFoundPage'),
  ),
);

export const GeneralRoutes = () => {
  const navigate = useNavigate();
  const { setModuleLoaded, isModuleLoaded } = useModuleLoad();

  const handleMicrofrontendReady = (key) => {
    if (isModuleLoaded(key)) return;
    setModuleLoaded(key);
  };

  const onChangePath = (parent, path) => {
    navigate(`${parent}${path}`);
  };

  return (
    <Routes>
      <Route element={<Initializer />}>
        <Route path="/auth/:token" element={<AuthPage />} />
        {/* <Route path="/iman" element={<ImanPage />} /> */}
        <Route path="/checkout/:checkoutId" element={<CheckoutPage />} />
        <Route path="/dashboard/*" element={<FSOVManagementLayoutLazy />} />
        <Route path="/simulator/*" element={<SimulatorLayoutLazy />} />
        <Route
          path="/calculator/*"
          element={
            <Suspense fallback={<Spinner fullPage></Spinner>}>
              <RemoteCalculatorApp
                onChangePath={(path) => {
                  onChangePath('/calculator', path);
                }}
                onLoadCallback={() => handleMicrofrontendReady('calculator')}
              />
            </Suspense>
          }
        />
        <Route path="/wizard" element={<WizardPage />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/configurationCreator" element={<ConfigurationCreatorPage />} />

        <Route path="/error" element={<ErrorPage />} />
        <Route path="*" element={<Navigate to={'/error'} replace />} />
      </Route>
    </Routes>
  );
};
